import type { Database, contract } from '@hvf/contracts'
import { createORPCClient, onError } from '@orpc/client'
import { RPCLink } from '@orpc/client/fetch'
import type { ContractRouterClient } from '@orpc/contract'
import { user } from '@stateApp'

import { type SupabaseClient, createClient } from '@supabase/supabase-js'

let supabase: SupabaseClient<Database>

export const api = () => {
	if (!supabase) {
		const url = import.meta.env.VITE_SUPABASE_URL
		const key = import.meta.env.VITE_SUPABASE_API_KEY

		console.log(`initilaising supabase client with: \n${url}\n${key}`)
		supabase = createClient<Database>(url, key)
	}

	return supabase
}

const link = new RPCLink({
	url: `${import.meta.env.VITE_OPERATIONS_URL}/rpc`,
	// Remove the inner function wrapper around the authorization value
	headers: () => {
		const token = user()?.access_token
		return {
			authorization: token ? `Bearer ${token}` : undefined, // Return the string directly
		}
	},
	interceptors: [
		onError((error) => {
			console.error('API Error:', error)

			// Helper to check for status code in various error shapes
			const status = (error as any)?.status || (error as any)?.statusCode

			// 401 Unauthorized: specific to authentication failure (expired/invalid token)
			if (status === 401) {
				console.log('🛑 401 Unauthorized detected - signing out...')
				// Force signout and redirect
				api()
					.auth.signOut()
					.finally(() => {
						if (window.location.pathname !== '/auth/login') {
							window.location.href = '/auth/login'
						}
					})
			}
			// 403 Forbidden: usually permissions.
			// We log it, but typically don't force logout unless required by the app.
			if (status === 403) {
				console.warn('🛑 403 Forbidden - User may lack permissions.')
				// Option: Toast notification could go here
			}
		}),
	],
})

export const client: ContractRouterClient<typeof contract> = createORPCClient(link)
